import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import createTrack from 'services/actions/tracker_actions';
import { ApiRequestStatusInfo, getApiRequestStatus } from 'services/conlicitacao_api_request';
import QuestionnaireExport from '../QuestionnaireExport';
import { Container } from '../styles';

const REQUEST_PATH = '/conlicitacao_api/solicitacao';

const API_DOC_URL = `${process.env.PUBLIC_URL}/docs/documentacao-api-conlicitacao.pdf`;

const ApiRequestPresentation: React.FC = () => {
  const history = useHistory();
  const [serverStatus, setServerStatus] = useState<ApiRequestStatusInfo | null>(null);
  const [statusLoaded, setStatusLoaded] = useState<boolean>(false);

  useEffect(() => {
    createTrack('Acessou solicitação de API', {});
    document.title = 'Solicitar API - ConLicitação';
  }, []);

  // Documentação aberta a qualquer cliente; só o botão final depende do status.
  useEffect(() => {
    let active = true;
    getApiRequestStatus()
      .then((info) => {
        if (active) setServerStatus(info);
      })
      .catch(() => {
        if (active) setServerStatus(null);
      })
      .finally(() => {
        if (active) setStatusLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  const emFluxo = Boolean(serverStatus);

  const goBack = () => history.push('/conlicitacao_api');
  const goToForm = () => history.push(`${REQUEST_PATH}?etapa=1`);
  const goToStatus = () => history.push(REQUEST_PATH);

  return (
    <Container>
      <div className="page-container">
        <div className="container-fluid big-resolutions py-5 px-md-5">
          <div className="row justify-content-center mt-3">
            <div className="col-12 col-lg-10 mx-auto">
              <button type="button" className="mb-3 px-0 btn btn-link" onClick={goBack}>
                <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar para a API
              </button>

              <div className="shadow-sm p-4 p-md-5 bg-white rounded">
                <h3 className="mb-3 font-weight-bold">Solicitar acesso à API ConLicitação</h3>
                <p className="card-text">
                  A API ConLicitação integra as informações dos seus boletins com ERPs, CRMs e
                  sistemas de gestão de licitações. É uma API REST, com respostas em JSON, que dá
                  acesso aos dados de cada um dos seus filtros de forma segura e organizada.
                </p>

                <p className="card-text font-weight-bold mt-4 mb-2">O que você precisa saber</p>
                <ul className="list-with-check mt-2 mb-0">
                  <li>
                    <span className="oi oi-check pr-2" />
                    Autenticação por token de acesso combinado com IP fixo. Cada cliente cadastra
                    até 10 IPs.
                  </li>
                  <li>
                    <span className="oi oi-check pr-2" />
                    Até 3 boletins por dia (09h45, 13h00 e 18h30). Você escolhe quantos e em quais
                    turnos.
                  </li>
                  <li>
                    <span className="oi oi-check pr-2" />
                    Os dados de um boletim fechado são imutáveis, e cada licitação tem um
                    identificador único.
                  </li>
                  <li>
                    <span className="oi oi-check pr-2" />
                    Alterações de filtro são feitas pelo time de Apoio e Relacionamento.
                  </li>
                </ul>

                <div className="border rounded p-3 mt-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                  <div className="mb-2 mb-md-0 pr-md-3">
                    <strong>Documentação completa da API</strong>
                    <div className="text-muted">
                      Biblioteca de dados, endpoints e exemplos de requisição e resposta.
                    </div>
                  </div>
                  <a
                    className="btn btn-outline-secondary flex-shrink-0"
                    href={API_DOC_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="material-icons align-middle mr-1">description</i>
                    Baixar PDF
                  </a>
                </div>

                <QuestionnaireExport compact={false} />

                <p className="card-text font-weight-bold mt-4 mb-2">Investimento</p>
                <p>
                  Os valores são definidos com o seu consultor, de acordo com a vigência do seu
                  contrato.
                </p>

                <div className="alert alert-warning mt-4" role="alert">
                  <div className="d-flex align-items-center mb-2">
                    <i className="material-icons mr-2" style={{ fontSize: '20px' }}>
                      info
                    </i>
                    <strong>Como funciona</strong>
                  </div>
                  <p className="mb-0">
                    Você preenche a solicitação em algumas etapas, aqui no portal. Nosso time
                    confere as informações e, estando tudo certo, ativa o acesso e libera o token. O
                    processo costuma levar de 1 a 2 dias úteis.
                  </p>
                </div>

                <div className="d-flex justify-content-end mt-4">
                  <button type="button" className="btn btn-link" onClick={goBack}>
                    Cancelar
                  </button>
                  {!statusLoaded ? (
                    <button type="button" className="btn btn-lg btn-submit ml-2" disabled>
                      Carregando…
                    </button>
                  ) : emFluxo ? (
                    <button
                      type="button"
                      className="btn btn-lg btn-submit ml-2"
                      onClick={goToStatus}
                    >
                      Acompanhar solicitação
                    </button>
                  ) : (
                    <button type="button" className="btn btn-lg btn-submit ml-2" onClick={goToForm}>
                      Continuar para a solicitação
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ApiRequestPresentation;
